
/**
 * 批注属性映射表
 * 原来的绿色对应的属性
 * 原来的红色对应的属性
 */
export const colorAttrMap = {
  'green': {
    'fill': '#bbedd0',
    'stroke': 'rgb(144, 237, 125)',
    'stroke-width': 1,
    'opacity': 0.8,
    'zIndex': 0,

  },
  'red': {
    'fill': '#ffa5a7',
    'stroke': '#fc6c6e',
    'stroke-width': 1,
    'opacity': 0.8,
    'zIndex': 0,
  },
};